/**
 * OptionsActions.js
 * Maps options menu buttons to actions
 */

import { CloseEventSource, CoreEvents, Game, UiMessageBox } from "pixi_core";

export class OptionsActions {
    /**
     * @public
     */
    constructor() {
        Game.on(CoreEvents.eOPTIONS_HOME, this._onOptionsHome, this);
        Game.on(CoreEvents.eOPTIONS_LEVEL_SELECTION, this._onOptionsLevelSelection, this);
        Game.on(CoreEvents.eOPTIONS_QUIT, this._onOptionsQuit, this);
        Game.on(CoreEvents.eOPTIONS_RESTART, this._onOptionsRestart, this);

        Game.on(CoreEvents.eOPTIONS_OPENING, this._onPopupOpening, this);
        Game.on(CoreEvents.eOPTIONS_CLOSING, this._onPopupClosing, this);
        Game.on(CoreEvents.eOPTIONS_HELP_MENU, this._onNavigationFoward, this);
        Game.on(CoreEvents.eOPTIONS_TOGGLE_SOUND, this._onNavigationFoward, this);
        Game.on(CoreEvents.eOPTIONS_LANGUAGE_MENU, this._onNavigationFoward, this);
        Game.on(CoreEvents.eOPTIONS_SETTINGS_MENU, this._onNavigationFoward, this);
        Game.on(CoreEvents.eOPTIONS_BACK, this._onNavigationBackward, this);

        Game.on(CoreEvents.eHELP_MENU_BUTTON_CLOSE, this._onNavigationBackward, this);
        Game.on(CoreEvents.eHELP_MENU_PAGE_CHANGING, this._onNavigationPageChanging, this);

        Game.on(CoreEvents.eLANGUAGE_MENU_LANGUAGE_SELECTED, this._onNavigationFoward, this);
        Game.on(CoreEvents.eLANGUAGE_MENU_BUTTON_CLOSE, this._onNavigationFoward, this);

        Game.on(CoreEvents.eMESSAGEBOX_OPENING, this._onMessageBoxOpening, this);
        Game.on(CoreEvents.eMESSAGEBOX_CLOSED, this._onMessageBoxClosed, this);
        Game.on(CoreEvents.eMESSAGEBOX_BUTTON_CONFIRM, this._onNavigationFoward, this);
        Game.on(CoreEvents.eMESSAGEBOX_BUTTON_CANCEL, this._onNavigationBackward, this);

        Game.on(CoreEvents.eCHEATS_MENU_OPENED, this._onNavigationFoward, this);
        Game.on(CoreEvents.eCHEATS_MENU_CLOSED, this._onNavigationBackward, this);
    }

    /**
     * The home button has been tapped
     * @private
     */
    _onOptionsHome() {
        Game.windows.messageBox.open({
            message: Game.localization.getText("IDS_MSGBOX_SHORT_RETURN_MAIN_MENU"),
            onConfirm: this._onHomeConfirm.bind(this)
        });
    }

    /**
     * The home button has been tapped
     * @private
     */
    _onOptionsLevelSelection() {
        Game.windows.messageBox.open({
            message: Game.localization.getText("IDS_MSGBOX_SHORT_RETURN_LEVEL_SELECTION"),
            onConfirm: this._onLevelSelectionConfirm.bind(this)
        });
    }

    /**
     * Moving back to the title screen.
     * @private
     */
    _onHomeConfirm() {
        Game.windows.changeContext("WindowTitle");
    }

    /**
     * Moving back to the title screen.
     * @private
     */
    _onLevelSelectionConfirm() {
        Game.windows.changeContext("WindowLevelSelection");
    }

    /**
     * The quit button has been tapped
     * @private
     */
    _onOptionsQuit() {
        Game.windows.messageBox.open({
            message: Game.localization.getText("IDS_MSGBOX_SHORT_QUIT_GAME"),
            onConfirm: this._onQuitConfirm.bind(this)
        });
    }

    /**
     * Close the application.
     * @private
     */
    _onQuitConfirm() {
        Game.fire(CoreEvents.eANDROID_EXIT);
        document.dispatchEvent(new Event("ge:wrapper:exit"));
    }

    /**
     * @private
     */
    _onOptionsRestart() {
        Game.windows.messageBox.open({
            message: Game.localization.getText("IDS_MSGBOX_LONG_RESTART_LEVEL"),
            onConfirm: this._onRestartConfirm.bind(this)
        });
    }

    /**
     * @private
     */
    _onRestartConfirm() {
        Game.windows.changeContext("WindowGame");
    }

    /**
     * @private
     * @param {UiMessageBox} messageBox
     * @param {Object} event
     */
    _onMessageBoxOpening(messageBox, event) {
        Game.audio.playSfx("IDSND_POPUP_OPEN");
    }

    /**
     * @private
     * @param {UiMessageBox} messageBox
     * @param {Object} event
     */
    _onMessageBoxClosed(messageBox, event) {
        if (event && (event.closeSource === CloseEventSource.eTAP_ANYWHERE || event.closeSource === CloseEventSource.eESCAPE_KEY)) {
            Game.audio.playSfx("IDSND_NAVIG_BACK");
        }
    }

    /**
     * @private
     */
    _onPopupOpening() {
        Game.audio.playSfx("IDSND_POPUP_OPEN");
    }

    /**
     * @private
     */
    _onPopupClosing() {
        Game.audio.playSfx("IDSND_POPUP_CLOSE");
    }

    /**
     * @private
     */
    _onNavigationFoward() {
        Game.audio.playSfx("IDSND_NAVIG_FORWARD");
    }

    /**
     * @private
     */
    _onNavigationBackward() {
        Game.audio.playSfx("IDSND_NAVIG_BACK");
    }

    /**
     * The content page has started changing (swipe or button interaction)
     * @private
     * @param {Number} nextPageIndex
     * @param {Number} previousPageIndex
     */
    _onNavigationPageChanging(nextPageIndex, previousPageIndex) {
        // No change
        if (nextPageIndex === previousPageIndex) return;

        // Swiped right
        if (nextPageIndex === previousPageIndex + 1) {
            this._onNavigationFoward();
            return;
        }

        // Swiped left
        if (nextPageIndex === previousPageIndex - 1) {
            this._onNavigationBackward();
            return;
        }
    }
}
